import { Avatar, Button, message, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { PageContext } from '../../../../lib/context';
import DashboardPage from './roles';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import queries from '../../../../utils/gql/queries';
import Form from 'rc-field-form/es/Form';
import { useForm } from 'antd/lib/form/Form';
import mutations from '../../../../utils/gql/mutations';

interface Roles {
  id: number;
  name: string;
}

const initial = {
  customers: false,
  billings: false,
  meters: false,
  rates: false,
  payments: false,
  additional_fees: false,
  settings: false,
  user_management: false,
};

export default function RolesController() {
  const [getRoles, { data, error, loading }] = useLazyQuery(queries.GET_ROLES, {
    fetchPolicy: 'no-cache',
  });
  const [usersData, setUsersData] = useState<Roles[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(false);
  const [settings, setSettings] = useState<object>({ ...initial });
  const [addRole] = useMutation(mutations.CREATE_ROLES, {
    onCompleted(res) {
      message.success('Role created or updated!');
      setShow(false);
      form.resetFields();
      getRoles();
    },
    onError() {
      message.error('There is an error try again!');
    },
  });

  useEffect(() => {
    if (data) {
      const roles = [...data.roles].map(roles => {
        return {
          ...roles,
          // name: `${subscriber.first_name} ${subscriber.last_name}`,
        };
      });
      setUsersData(roles);
    }
  }, [data, error]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const usersColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    {
      title: 'Edit',
      key: 'edit',
      render: (val: any) => (
        <Button type="link" onClick={() => _editHandler(val)}>
          Edit
        </Button>
      ),
    },
  ];

  const [form] = useForm();

  const _onFinish = (data: any) => {
    addRole({
      variables: {
        data: {
          name: data.name.toLowerCase(),
          ...settings,
        },
      },
    });
  };

  const _editHandler = (data: any) => {
    form.setFieldsValue({ name: data.name });
    const newData = { ...data };
    delete newData.name;
    delete newData.__typename;
    setSettings({ ...newData });
    setShow(true);
  };

  const _showHandler = () => {
    setShow(true);
    form.resetFields();
    setSettings({ ...initial });
  };
  const _closeHandler = () => {
    setShow(false);
    setDisplay(true);
    form.resetFields();
  };

  const _submitHandler = () => {
    form.submit();
  };

  const values = {
    data,
    usersData,
    usersColumns,
    form,
    show,
    display,
    settings,
    loading,
    setSettings,
    setDisplay,
    setShow,
    _submitHandler,
    _onFinish,
    _showHandler,
    _closeHandler,
    _editHandler,
  };

  return (
    <PageContext.Provider value={values}>
      <DashboardPage />
    </PageContext.Provider>
  );
}
